var $fe1eccf4ee1d6f52$exports = {};
$fe1eccf4ee1d6f52$exports = {
    "Empty": `Gol`
};


export {$fe1eccf4ee1d6f52$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
